// extracted by mini-css-extract-plugin
export default {"root":"Toggle_root__GJow7","indicator":"Toggle_indicator__EqOP7"};